import React from "react";

const Close: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    viewBox="0 0 1024 1024"
    width={200}
    height={200}
    className="icon"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M29.269333 29.269333a85.333333 85.333333 0 0 0 0 120.661334l844.8 844.8a85.333333 85.333333 0 0 0 120.661334-120.661334l-844.8-844.8a85.333333 85.333333 0 0 0-120.661334 0z" />
    <path d="M994.730667 29.269333a85.333333 85.333333 0 0 1 0 120.661334l-844.8 844.8a85.333333 85.333333 0 0 1-120.661334-120.661334l844.8-844.8a85.333333 85.333333 0 0 1 120.661334 0z" />
  </svg>
);

export default Close;
